module.exports = __webpack_public_path__ + "img/landos-banner.png?8fbea9c7314581ea78f40427691a768c";